<template>
  <div>
    <div style="display: flex">
      <div v-for="(item,index) in menuList" :key="index" class="menu-father">
        {{item.name}}
        <el-menu class="menu" router
                 active-text-color="white"
                 :default-active="0">
          <son-menu :data="item.menu"/>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import SonMenu from "../../frame/components/aside/SonMenu";
export default {
  name: "Menu",
  components:{SonMenu},
  data() {
    return {
      menuList:[]
    }
  },
  created() {
    let menu = JSON.parse(localStorage.getItem("user")).systemList;
    console.log(menu)
    this.menuList = menu;
  }
}
</script>

<style scoped>
.menu{
  border: none;
}
.menu-father{
  width: 260px;
  border-radius: 20px;
  box-shadow: 0 0px 16px rgba(121, 121, 121, 0.1);
  padding: 20px;
  margin: 10px 20px;
  height: 77vh;
  overflow: auto;
}
.menu-father:hover {
  box-shadow: 0 0px 16px rgba(92, 92, 92, 0.2);
}
</style>